import dayjs from 'dayjs'

export const MIN_AGE_YEARS = 18
export const MAX_AGE_YEARS = 100

const yearError = (yearStr: string): string | null => {
  const year = Number(yearStr)
  const currentYear = dayjs().year()
  return /^\d{4}$/.test(yearStr) &&
    year >= currentYear - MAX_AGE_YEARS &&
    year <= currentYear
    ? null
    : 'personalInfo.error.invalidYear'
}

const monthError = (monthStr: string): string | null =>
  /^\d{1,2}$/.test(monthStr) && Number(monthStr) >= 1 && Number(monthStr) <= 12
    ? null
    : 'personalInfo.error.invalidMonth'

const dayError = (
  dayStr: string,
  yearStr: string,
  monthStr: string
): string | null => {
  const day = Number(dayStr)
  if (!/^\d{1,2}$/.test(dayStr) || day < 1 || day > 31) {
    return 'personalInfo.error.invalidDay'
  }
  const month = Number(monthStr)
  const monthKnown = /^\d{1,2}$/.test(monthStr) && month >= 1 && month <= 12
  const yearKnown = /^\d{4}$/.test(yearStr)
  if (monthKnown && yearKnown) {
    const date = new Date(Number(yearStr), month - 1, day)
    if (date.getMonth() !== month - 1 || date.getDate() !== day) {
      return 'personalInfo.error.invalidDay'
    }
  }
  return null
}

const birthDateError = (
  yearStr: string,
  monthStr: string,
  dayStr: string
): string | null => {
  const date = new Date(Number(yearStr), Number(monthStr) - 1, Number(dayStr))
  if (dayjs(date).isAfter(dayjs().startOf('day'))) {
    return 'personalInfo.error.invalidDate'
  }
  if (dayjs().diff(dayjs(date), 'year') < MIN_AGE_YEARS) {
    return 'personalInfo.error.ageRestriction'
  }
  return null
}

export const normalizeDob = (dob: string): string => {
  const [year = '', month = '', day = ''] = dob.split('-')
  const pad = (part: string) => (/^\d$/.test(part) ? `0${part}` : part)
  return `${year}-${pad(month)}-${pad(day)}`
}

export type DobFieldErrors = {
  year: string | null
  month: string | null
  day: string | null
  date: string | null
}

// Returns the i18n error key for each birthday field (null when valid). `date`
// carries whole-date errors (future/age) once year, month and day are each valid.
export const getDobFieldErrors = (dob: string): DobFieldErrors => {
  const [yearStr = '', monthStr = '', dayStr = ''] = dob.split('-')
  const year = yearError(yearStr)
  const month = monthError(monthStr)
  const day = dayError(dayStr, yearStr, monthStr)
  const date =
    year || month || day ? null : birthDateError(yearStr, monthStr, dayStr)
  return { year, month, day, date }
}
